import { createAction, handleActions } from "redux-actions"
import { apiGet, apiPost, apiPut } from "../utils/apiConnector"
import {
  productApi,
  uploadImageApi,
  putProductApi,
  addToCategoryApi,
} from "../config/apiUrls"

const defaultState = {
  product: {
    attributes: [],
    name: "",
    barcode: "",
    images: [],
    catalogId: "",
    purchasePrice: "",
    salePrice: "",
    shortName: "",
    remainder: "",
    measureId: "",
  },
}

const setProductData = createAction("SET_PRODUCT_DATA")

const reducers = handleActions(
  {
    [setProductData]: (state, { payload }) => ({
      ...state,
      product: payload,
    }),
  },
  defaultState,
)

export default reducers

// Thunk
export function getProduct(stockId) {
  return (dispatch) => {
    return apiGet(productApi, {
      stockId: stockId,
    })
      .onOk((res) => {
        dispatch(setProductData(res.data.response))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        //
      })
      .startSingle(stockId)
  }
}

export function putProduct(barcode, name, salePrice, purchasePrice, measureId) {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    let fd = new FormData()
    fd.append("barcode", barcode)
    fd.append("name", name)
    fd.append("salePrice", parseFloat(salePrice))
    fd.append("purchasePrice", parseFloat(purchasePrice))
    fd.append("measureId", parseInt(measureId))
    fd.append("storeId", storeId)
    const json = {
      storeId: parseInt(storeId),
      barcode: barcode,
      name: name,
      salePrice: parseFloat(salePrice),
      purchasePrice: parseFloat(purchasePrice),
      measureId: parseInt(measureId),
    }
    return apiPut(putProductApi, JSON.stringify(json))
      .onOk((res) => {
        //
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        //
      })
      .startSingle(storeId)
  }
}

export function postImage(catalogId, images) {
  let fd = new FormData()
  fd.append("catId", catalogId)
  fd.append("files", images)
  return (dispatch) => {
    return apiPost(uploadImageApi, fd)
      .onOk((res) => {
        //
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        //
      })
      .startSingle(catalogId)
  }
}

export function deleteImages(catalogId, images) {
  return (dispatch) => {
    return apiPut(uploadImageApi, JSON.stringify(images))
      .onOk((res) => {
        //
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        //
      })
      .startSingle(catalogId)
  }
}

export function addToCategory(stockId, categoryId) {
  return (dispatch) => {
    let fd = new FormData()
    fd.append("stockId", stockId)
    fd.append("categoryId", categoryId)
    const json = { stockId: stockId, categoryId: categoryId }
    return apiPut(addToCategoryApi, JSON.stringify(json))
      .onOk((res) => {
        //
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        //
      })
      .startSingle(stockId)
  }
}

// deleteFromCategory
